import React from "react";
import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";
import { Modal, ModalBody, ModalFooter } from "../modal";
import { RaboButton } from "../rabo-button";
import { cn } from "../utils";
import { typography } from "../tokens";

/**
 * Evet / Hayır onay diyaloğu — create, delete ve diğer geri alınamaz işlemler için.
 */
export function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel,
  cancelLabel,
  variant = "default",
  loading = false,
  onConfirm,
  onCancel,
}) {
  const { t } = useTranslation();

  if (!open) return null;

  const isDanger = variant === "danger";
  const yesLabel = confirmLabel ?? t("common.confirm.yes", "Evet");
  const noLabel = cancelLabel ?? t("common.confirm.no", "Hayır");

  return (
    <Modal maxWidth="max-w-md" overlayZIndex="z-[300000]" onClose={onCancel}>
      <ModalBody className="pt-6 pb-2">
        <div className="flex gap-4">
          <div
            className={cn(
              "flex h-11 w-11 shrink-0 items-center justify-center rounded-full",
              isDanger ? "bg-red-50 text-red-600" : "bg-blue-50 text-blue-600"
            )}
          >
            <AlertTriangle className="h-5 w-5" aria-hidden="true" />
          </div>
          <div className="min-w-0 flex-1">
            <h3 className="text-gray-900" style={typography.modalTitle}>
              {title}
            </h3>
            {message && (
              <p className="mt-2 text-gray-500" style={typography.body}>
                {message}
              </p>
            )}
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <RaboButton variant="outline" size="md" onClick={onCancel} disabled={loading}>
          {noLabel}
        </RaboButton>
        <RaboButton
          variant={isDanger ? "danger" : "primary"}
          size="md"
          onClick={onConfirm}
          disabled={loading}
        >
          {yesLabel}
        </RaboButton>
      </ModalFooter>
    </Modal>
  );
}
